// Helper to format currency
export const formatCurrency = (amount: number, currency: 'USD' | 'BRL', locale: string) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount / 100)
}
